<template>
  <div class="flex aic teainfo">
          <van-image
            round
            class="avater"
            src="https://img01.yzcdn.cn/vant/cat.jpeg"
          />
          <div class="flex aic jc-sb">
            <div class="info">
              <div class="name">詹三</div>
              <div class="msg">20粉丝 | 课程12</div>
            </div>
            <!-- <van-button type="info" class="focusbtn" round>+ 关注Ta</van-button> -->
            <van-button type="info" icon="success" class="unfocusbtn" round
              >已关注</van-button
            >
          </div>
        </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
.teainfo{
    width: 100%;
    .avater{
        width: 48px;
        height: 48px;
    }
     .focusbtn {
    width: 78px;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    text-align: center;
    font-family: -apple-system;
    padding: 0;
  }
  .unfocusbtn {
    width: 78px;
    height: 30px;
    line-height: 20px;
    border-radius: 60px;
    background-color: rgba(245, 246, 248, 100);
    text-align: center;
    border: 1px solid rgba(255, 255, 255, 100);
    color: rgba(153, 153, 153, 100);
    padding: 0;
    font-size: 14px;
  }
  .info {
    width: 196px;
    margin-left: 10px;
    .name {
      height: 22px;
      color: rgba(48, 91, 119, 100);
      font-size: 16px;
      text-align: left;
      font-family: PingFangSC-regular;
    }
    .msg {
      height: 17px;
      color: rgba(153, 153, 153, 100);
      font-size: 12px;
      text-align: left;
      font-family: PingFangSC-regular;
    }
  }
}
</style>